import { appendTelemetryHeaders } from './telemetry';

const telemetryPathPrefixes = ['/api/', '/rpc/', '/agent/', '/v1/'];

let installed = false;
let baseFetch: typeof fetch | null = null;

function resolveRequestURL(input: RequestInfo | URL): URL | null {
  try {
    if (typeof input === 'string') {
      return new URL(input, window.location.origin);
    }
    if (input instanceof URL) {
      return new URL(input.toString(), window.location.origin);
    }
    if (input instanceof Request) {
      return new URL(input.url, window.location.origin);
    }
  } catch {
    return null;
  }
  return null;
}

function shouldInjectTelemetry(input: RequestInfo | URL): boolean {
  const url = resolveRequestURL(input);
  if (!url) {
    return false;
  }
  if (url.origin !== window.location.origin) {
    return false;
  }
  return telemetryPathPrefixes.some((prefix) => url.pathname.startsWith(prefix));
}

function mergeHeaders(input: RequestInfo | URL, init: RequestInit): Headers {
  const merged = new Headers(input instanceof Request ? input.headers : undefined);
  const overrides = new Headers(init.headers);
  overrides.forEach((value, key) => {
    merged.set(key, value);
  });
  return merged;
}

export function fetchWithTelemetry(
  input: RequestInfo | URL,
  init: RequestInit = {}
): Promise<Response> {
  const fetchImpl = baseFetch ?? globalThis.fetch.bind(globalThis);

  if (!shouldInjectTelemetry(input)) {
    return fetchImpl(input, init);
  }

  const headers = mergeHeaders(input, init);
  appendTelemetryHeaders(headers);
  return fetchImpl(input, {
    ...init,
    headers,
  });
}

export function installFetchWithTelemetry(): void {
  if (installed) {
    return;
  }
  baseFetch = globalThis.fetch.bind(globalThis);
  globalThis.fetch = fetchWithTelemetry as typeof fetch;
  installed = true;
}
